import React from 'react';
import PropTypes from 'prop-types';
import useCountUp from '../../hooks/useCountUp.js';

const AnimatedCount = ({target, duration, format, animate = true}) => {
  const animated = useCountUp(target ?? 0, duration);
  const value = animate ? animated : (target ?? 0);
  const rounded = Math.round(value);
  return <>{format ? format(rounded) : rounded}</>;
};

AnimatedCount.propTypes = {
  target: PropTypes.number,
  duration: PropTypes.number,
  format: PropTypes.func,
  animate: PropTypes.bool,
};

export default AnimatedCount;
